import { makeStyles, Typography } from '@material-ui/core'
import React from 'react'
import { IInputProps } from 'src/types'
import GenericInput from './GenericInput'

const useStyles = makeStyles({
  objectPropertiesContainer: {
    margin: 8,
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
})

const ObjectInput = <T extends object>({
  onChange,
  value,
  name,
  property,
}: IInputProps<T>): JSX.Element => {
  const { properties = {}, additionalProperties } = property
  let additionalData: string[] | null = null

  if (additionalProperties !== undefined) {
    additionalData = Object.keys(value ?? {}).filter(
      key => !Object.keys(properties).includes(key),
    )
  }
  const classes = useStyles()

  return (
    <div>
      <Typography variant='body1'>{property.displayedName ?? name}</Typography>
      <div className={classes.objectPropertiesContainer}>
        {Object.keys(properties).map(propertyKey => {
          return (
            <GenericInput
              key={propertyKey}
              // @ts-ignore
              property={properties[propertyKey]}
              name={propertyKey}
              onChange={e => {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                onChange({
                  ...value,
                  [propertyKey]: e,
                } as T)
              }}
              value={value?.[propertyKey]}
              placeholder={propertyKey}
            />
          )
        })}
        {Array.isArray(additionalData) &&
          additionalData.map(propertyKey => {
            return (
              <GenericInput
                key={propertyKey}
                // @ts-ignore
                property={property.additionalProperties}
                name={propertyKey}
                onChange={e => {
                  onChange({
                    ...value,
                    [propertyKey]: e,
                  } as T)
                }}
                value={value?.[propertyKey]}
                label={propertyKey}
                placeholder={propertyKey}
              />
            )
          })}
      </div>
    </div>
  )
}

export default ObjectInput
